import React, { useState } from 'react';
import './AdminPanel.css';

const PASSCODE = '1963';
const STORAGE_KEY = 'portfolio_data';

export const DEFAULT_DATA = {
  hero: {
    badge: 'Available for opportunities',
    firstName: 'Elmehdi',
    lastName: 'Elmouate',
    role: 'Full-Stack Developer',
    description: 'Software Developer building production-grade backend systems, full-stack web apps, and AI-powered solutions. Passionate about clean architecture, DevOps, and shipping real products.',
    photoUrl: '/mehdi.jpg',
    githubUrl: 'https://github.com/GitMehdi-sys',
    linkedinUrl: 'https://www.linkedin.com/in/el-mehdi-el-mouate-476875300',
  },
  about: {
    lead: 'Software Developer with hands-on experience building scalable backend systems, RESTful APIs, and AI-integrated applications from the ground up.',
    paragraph1: 'I specialize in backend engineering with Spring Boot and Node.js, full-stack development with React, and building intelligent systems using Python, Ollama, and RAG pipelines. I apply CI/CD practices, containerization with Docker, and secure authentication with JWT and Spring Security across every project.',
    paragraph2: 'Every line of code I write is driven by a commitment to clean architecture, performance, and real-world impact — from database design with MariaDB and MongoDB to deploying on Ubuntu servers with Jenkins pipelines.',
    stats: [{ value: '3+', label: 'Years Coding' }, { value: '20+', label: 'Technologies' }, { value: '10+', label: 'Projects' }],
    codeWindow: 'public class Developer {\n  String name    = "Elmehdi";\n  String focus   = "Backend";\n  String[] stack = {\n    "Spring Boot", "Node.js",\n    "React", "Docker", "AI"\n  };\n\n  void work() {\n    while (alive) {\n      learn(); build(); ship();\n    }\n  }\n}',
  },
  projects: [
    { title: 'GlobalAssist', tech: 'Python · FastAPI · OAuth', description: 'Multi-AI coding assistant integrating GPT, Claude, and Gemini with OAuth authentication, file uploads, and chat history management.', highlights: ['Multi-model AI', 'OAuth Auth', 'File Management', 'Real-time Chat'], github: 'https://github.com/GitMehdi-sys/GlobalAssist', live: '', color: '#6dd56e' },
    { title: 'Chatbot', tech: 'Python · NLP', description: 'Intelligent conversational AI with natural language understanding and context-aware responses for enhanced user interaction.', highlights: ['Conversational AI', 'Context Management', 'NLP Processing'], github: 'https://github.com/GitMehdi-sys/chatbot', live: '', color: '#4caf50' },
    { title: 'Humanizer', tech: 'Python · NLP', description: 'Text processing tool that transforms AI-generated content into natural, human-like language through advanced NLP techniques.', highlights: ['Text Transformation', 'Advanced NLP', 'Content Enhancement'], github: 'https://github.com/GitMehdi-sys/humanizer', live: '', color: '#b5e48c' },
  ],
  skills: {
    Languages: [
      { name: 'Java', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg', type: 'url' },
      { name: 'Python', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg', type: 'url' },
      { name: 'JavaScript', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg', type: 'url' },
      { name: 'TypeScript', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg', type: 'url' },
      { name: 'C', icon: '', type: 'svg', svgMarkup: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 48 48"><path fill="#283593" fillRule="evenodd" d="M22.903,3.286c0.679-0.381,1.515-0.381,2.193,0 c3.355,1.883,13.451,7.551,16.807,9.434C42.582,13.1,43,13.804,43,14.566c0,3.766,0,15.101,0,18.867 c0,0.762-0.418,1.466-1.097,1.847c-3.355,1.883-13.451,7.551-16.807,9.434c-0.679,0.381-1.515,0.381-2.193,0 c-3.355-1.883-13.451-7.551-16.807-9.434C5.418,34.899,5,34.196,5,33.434c0-3.766,0-15.101,0-18.867 c0-0.762,0.418-1.466,1.097-1.847C9.451,10.837,19.549,5.169,22.903,3.286z" clipRule="evenodd"/><path fill="#5c6bc0" fillRule="evenodd" d="M5.304,34.404C5.038,34.048,5,33.71,5,33.255 c0-3.744,0-15.014,0-18.759c0-0.758,0.417-1.458,1.094-1.836c3.343-1.872,13.405-7.507,16.748-9.38 c0.677-0.379,1.594-0.371,2.271,0.008c3.343,1.872,13.371,7.459,16.714,9.331c0.27,0.152,0.476,0.335,0.66,0.576L5.304,34.404z" clipRule="evenodd"/><path fill="#fff" fillRule="evenodd" d="M24,10c7.727,0,14,6.273,14,14s-6.273,14-14,14 s-14-6.273-14-14S16.273,10,24,10z M24,17c3.863,0,7,3.136,7,7c0,3.863-3.137,7-7,7s-7-3.137-7-7C17,20.136,20.136,17,24,17z" clipRule="evenodd"/><path fill="#3949ab" fillRule="evenodd" d="M42.485,13.205c0.516,0.483,0.506,1.211,0.506,1.784 c0,3.795-0.032,14.589,0.009,18.384c0.004,0.396-0.127,0.813-0.323,1.127L23.593,24L42.485,13.205z" clipRule="evenodd"/></svg>' },
      { name: 'SQL', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg', type: 'url' },
      { name: 'HTML5', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg', type: 'url' },
      { name: 'CSS3', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg', type: 'url' },
      { name: 'Solidity', icon: '', type: 'svg', svgMarkup: '<svg viewBox="0 0 128 128" width="36" height="36"><path fill="#6C6C6C" d="M63.986 2L32 57.064 63.986 44.477 96 57.064Z"/><path fill="#9B9B9B" d="M32 57.064L63.986 44.477 63.986 2Z"/><path fill="#C1C1C1" d="M63.986 44.477L96 57.064 63.986 2Z"/><path fill="#6C6C6C" d="M63.986 126L96 70.936 63.986 83.523 32 70.936Z"/><path fill="#9B9B9B" d="M96 70.936L63.986 83.523 63.986 126Z"/><path fill="#C1C1C1" d="M63.986 83.523L32 70.936 63.986 126Z"/></svg>' },
    ],
    'Frameworks & Libraries': [
      { name: 'Spring Boot', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg', type: 'url' },
      { name: 'React', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg', type: 'url' },
      { name: 'Node.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg', type: 'url' },
      { name: 'Express.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg', type: 'url' },
      { name: 'Flask', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flask/flask-original.svg', type: 'url' },
      { name: 'Tailwind CSS', icon: '', type: 'svg', svgMarkup: '<svg viewBox="0 0 54 33" width="36" height="22"><path fill="#b5e48c" fillRule="evenodd" clipRule="evenodd" d="M27 0C19.8 0 15.3 3.6 13.5 10.8c2.7-3.6 5.85-4.95 9.45-4.05 2.054.514 3.522 2.004 5.147 3.653C30.744 13.09 33.808 16.2 40.5 16.2c7.2 0 11.7-3.6 13.5-10.8-2.7 3.6-5.85 4.95-9.45 4.05-2.054-.514-3.522-2.004-5.147-3.653C36.756 3.11 33.692 0 27 0zM13.5 16.2C6.3 16.2 1.8 19.8 0 27c2.7-3.6 5.85-4.95 9.45-4.05 2.054.514 3.522-2.004 5.147 3.653C17.244 29.29 20.308 32.4 27 32.4c7.2 0 11.7-3.6 13.5-10.8-2.7 3.6-5.85 4.95-9.45 4.05-2.054-.514-3.522-2.004-5.147-3.653C23.256 19.31 20.192 16.2 13.5 16.2z"/></svg>' },
      { name: 'Hibernate', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/hibernate/hibernate-plain.svg', type: 'url' },
      { name: 'Spring Security', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg', type: 'url' },
    ],
    Databases: [
      { name: 'MySQL', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg', type: 'url' },
      { name: 'MongoDB', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg', type: 'url' },
      { name: 'MariaDB', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mariadb/mariadb-plain.svg', type: 'url' },
    ],
    'DevOps & Tools': [
      { name: 'Git', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg', type: 'url' },
      { name: 'Docker', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg', type: 'url' },
      { name: 'Jenkins', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-original.svg', type: 'url' },
      { name: 'Ubuntu', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/ubuntu/ubuntu-plain.svg', type: 'url' },
      { name: 'VS Code', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg', type: 'url' },
      { name: 'IntelliJ IDEA', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/intellij/intellij-original.svg', type: 'url' },
      { name: 'Postman', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postman/postman-original.svg', type: 'url' },
      { name: 'Maven', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/maven/maven-original.svg', type: 'url' },
    ],
    'Concepts & Practices': [
      { name: 'REST API', type: 'badge' }, { name: 'CRUD API', type: 'badge' }, { name: 'CI/CD', type: 'badge' },
      { name: 'JWT Auth', type: 'badge' }, { name: 'RAG', type: 'badge' }, { name: 'Embeddings', type: 'badge' },
      { name: 'Ollama', type: 'badge' }, { name: 'Email Sender', type: 'badge' }, { name: 'MVC Pattern', type: 'badge' },
      { name: 'Pytest', type: 'badge' }, { name: 'JUnit', type: 'badge' }, { name: 'Blockchain', type: 'badge' },
    ],
  },
  contact: {
    email: 'mehdielmo2020@gmail.com',
    subtitle: "Open to new projects, opportunities, and collaborations. Feel free to reach out!",
    githubUrl: 'https://github.com/GitMehdi-sys',
    linkedinUrl: 'https://www.linkedin.com/in/el-mehdi-el-mouate-476875300',
  },
  footer: {
    text: '© 2026 Elmehdi Elmouate — Designed & Built with React',
    quote: '"Clean code always looks like it was written by someone who cares."',
  },
};

export function loadPortfolioData() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) return { ...DEFAULT_DATA, ...JSON.parse(saved) };
  } catch (e) { console.error('Load failed:', e); }
  return DEFAULT_DATA;
}

export function savePortfolioData(data) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); return true; }
  catch (e) { console.error('Save failed:', e); return false; }
}

export function resetPortfolioData() {
  localStorage.removeItem(STORAGE_KEY);
  return DEFAULT_DATA;
}

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

// ─── Passcode Modal ───
function PasscodeModal({ onUnlock, onClose }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [shake, setShake] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code === PASSCODE) { onUnlock(); }
    else { setError('Wrong passcode'); setShake(true); setTimeout(() => setShake(false), 500); setCode(''); }
  };

  return (
    <div className="admin-overlay" onClick={onClose}>
      <div className={`passcode-modal${shake ? ' shake' : ''}`} onClick={(e) => e.stopPropagation()}>
        <h3>Admin Access</h3>
        <p>Enter passcode to continue</p>
        <form onSubmit={handleSubmit}>
          <input type="password" value={code} onChange={(e) => { setCode(e.target.value); setError(''); }} placeholder="Passcode" autoFocus className="admin-input" />
          {error && <span className="passcode-error">{error}</span>}
          <div className="passcode-actions">
            <button type="submit" className="admin-btn primary">Unlock</button>
            <button type="button" className="admin-btn ghost" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}

// ─── Image Uploader ───
function ImageUploader({ label, value, onChange }) {
  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const b64 = await fileToBase64(file);
    onChange(b64);
  };
  return (
    <div className="admin-field">
      <label>{label}</label>
      <div className="image-upload-row">
        <input type="text" value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder="URL or base64" className="admin-input" />
        <label className="admin-btn ghost file-btn">Upload<input type="file" accept="image/*" onChange={handleFile} hidden /></label>
      </div>
      {value && <div className="image-preview"><img src={value} alt="Preview" /></div>}
    </div>
  );
}

// ─── SVG Uploader ───
function SvgUploader({ label, value, onChange }) {
  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.name.endsWith('.svg')) { const text = await file.text(); onChange(text); }
    else { const b64 = await fileToBase64(file); onChange(b64); }
  };
  return (
    <div className="admin-field">
      <label>{label}</label>
      <label className="admin-btn ghost file-btn" style={{marginBottom:6}}>Upload SVG<input type="file" accept=".svg,image/svg+xml" onChange={handleFile} hidden /></label>
      {value && <div className="svg-preview" dangerouslySetInnerHTML={{ __html: value }} />}
      <textarea value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder="SVG markup" className="admin-textarea" rows={3} />
    </div>
  );
}

// ─── Hero Editor ───
function HeroEditor({ data, onChange }) {
  const u = (k, v) => onChange({ ...data, [k]: v });
  return (
    <div className="admin-section">
      <h4>Hero Section</h4>
      <div className="admin-field"><label>Badge Text</label><input className="admin-input" value={data.badge} onChange={(e) => u('badge', e.target.value)} /></div>
      <div className="admin-field"><label>First Name</label><input className="admin-input" value={data.firstName} onChange={(e) => u('firstName', e.target.value)} /></div>
      <div className="admin-field"><label>Last Name</label><input className="admin-input" value={data.lastName} onChange={(e) => u('lastName', e.target.value)} /></div>
      <div className="admin-field"><label>Role</label><input className="admin-input" value={data.role} onChange={(e) => u('role', e.target.value)} /></div>
      <div className="admin-field"><label>Description</label><textarea className="admin-textarea" rows={3} value={data.description} onChange={(e) => u('description', e.target.value)} /></div>
      <ImageUploader label="Profile Photo" value={data.photoUrl} onChange={(v) => u('photoUrl', v)} />
      <div className="admin-field"><label>GitHub URL</label><input className="admin-input" value={data.githubUrl} onChange={(e) => u('githubUrl', e.target.value)} /></div>
      <div className="admin-field"><label>LinkedIn URL</label><input className="admin-input" value={data.linkedinUrl} onChange={(e) => u('linkedinUrl', e.target.value)} /></div>
    </div>
  );
}

// ─── About Editor ───
function AboutEditor({ data, onChange }) {
  const u = (k, v) => onChange({ ...data, [k]: v });
  const updateStat = (i, f, v) => { const s = [...data.stats]; s[i] = { ...s[i], [f]: v }; onChange({ ...data, stats: s }); };
  return (
    <div className="admin-section">
      <h4>About Section</h4>
      <div className="admin-field"><label>Lead</label><textarea className="admin-textarea" rows={2} value={data.lead} onChange={(e) => u('lead', e.target.value)} /></div>
      <div className="admin-field"><label>Paragraph 1</label><textarea className="admin-textarea" rows={2} value={data.paragraph1} onChange={(e) => u('paragraph1', e.target.value)} /></div>
      <div className="admin-field"><label>Paragraph 2</label><textarea className="admin-textarea" rows={2} value={data.paragraph2} onChange={(e) => u('paragraph2', e.target.value)} /></div>
      <div className="admin-field"><label>Code Window</label><textarea className="admin-textarea code-textarea" rows={8} value={data.codeWindow} onChange={(e) => u('codeWindow', e.target.value)} /></div>
      <h4>Stats</h4>
      {data.stats.map((s, i) => (
        <div className="stat-editor-row" key={i}>
          <input className="admin-input small" value={s.value} onChange={(e) => updateStat(i, 'value', e.target.value)} placeholder="Value" />
          <input className="admin-input small" value={s.label} onChange={(e) => updateStat(i, 'label', e.target.value)} placeholder="Label" />
          <button className="admin-btn danger small" onClick={() => onChange({ ...data, stats: data.stats.filter((_, j) => j !== i) })}>×</button>
        </div>
      ))}
      <button className="admin-btn ghost small" onClick={() => onChange({ ...data, stats: [...data.stats, { value: '', label: '' }] })}>+ Add Stat</button>
    </div>
  );
}

// ─── Project Card Editor ───
function ProjectCardEditor({ project, onChange, onDelete }) {
  const u = (k, v) => onChange({ ...project, [k]: v });
  const updateH = (i, v) => { const h = [...project.highlights]; h[i] = v; onChange({ ...project, highlights: h }); };
  return (
    <div className="admin-card">
      <div className="admin-card-header"><span>{project.title || 'New Project'}</span><button className="admin-btn danger small" onClick={onDelete}>Delete</button></div>
      <div className="admin-field"><label>Title</label><input className="admin-input" value={project.title} onChange={(e) => u('title', e.target.value)} /></div>
      <div className="admin-field"><label>Tech</label><input className="admin-input" value={project.tech} onChange={(e) => u('tech', e.target.value)} /></div>
      <div className="admin-field"><label>Description</label><textarea className="admin-textarea" rows={2} value={project.description} onChange={(e) => u('description', e.target.value)} /></div>
      <div className="admin-field"><label>Color</label><input type="color" value={project.color} onChange={(e) => u('color', e.target.value)} className="admin-color" /></div>
      <div className="admin-field"><label>GitHub</label><input className="admin-input" value={project.github} onChange={(e) => u('github', e.target.value)} /></div>
      <div className="admin-field"><label>Live URL</label><input className="admin-input" value={project.live || ''} onChange={(e) => u('live', e.target.value)} /></div>
      <h5>Highlights</h5>
      {project.highlights.map((h, i) => (
        <div className="stat-editor-row" key={i}>
          <input className="admin-input small" value={h} onChange={(e) => updateH(i, e.target.value)} />
          <button className="admin-btn danger small" onClick={() => onChange({ ...project, highlights: project.highlights.filter((_, j) => j !== i) })}>×</button>
        </div>
      ))}
      <button className="admin-btn ghost small" onClick={() => onChange({ ...project, highlights: [...project.highlights, ''] })}>+ Add</button>
    </div>
  );
}

// ─── Projects Editor ───
function ProjectsEditor({ data, onChange }) {
  const updateP = (i, p) => { const n = [...data]; n[i] = p; onChange(n); };
  const deleteP = (i) => onChange(data.filter((_, j) => j !== i));
  const addP = () => onChange([...data, { title: '', tech: '', description: '', highlights: [], github: '', live: '', color: '#6dd56e' }]);
  return (
    <div className="admin-section">
      <h4>Projects</h4>
      {data.map((p, i) => <ProjectCardEditor key={i} project={p} onChange={(p) => updateP(i, p)} onDelete={() => deleteP(i)} />)}
      <button className="admin-btn primary" onClick={addP}>+ Add Project</button>
    </div>
  );
}

// ─── Skill Item Editor ───
function SkillItemEditor({ item, onChange, onDelete }) {
  const u = (k, v) => onChange({ ...item, [k]: v });
  return (
    <div className="admin-card compact">
      <div className="admin-card-header"><span>{item.name || 'New Skill'}</span><button className="admin-btn danger small" onClick={onDelete}>×</button></div>
      <div className="admin-field inline"><label>Name</label><input className="admin-input" value={item.name} onChange={(e) => u('name', e.target.value)} /></div>
      {item.type === 'badge' ? null : (
        <>
          <div className="admin-field inline"><label>Type</label>
            <select className="admin-input" value={item.type} onChange={(e) => u('type', e.target.value)}>
              <option value="url">Icon URL</option><option value="svg">SVG Markup</option>
            </select>
          </div>
          {item.type === 'url' ? (
            <div className="admin-field inline"><label>Icon URL</label><input className="admin-input" value={item.icon || ''} onChange={(e) => u('icon', e.target.value)} /></div>
          ) : (
            <SvgUploader label="SVG" value={item.svgMarkup || ''} onChange={(v) => u('svgMarkup', v)} />
          )}
        </>
      )}
    </div>
  );
}

// ─── Skills Editor ───
function SkillsEditor({ data, onChange }) {
  const categories = Object.keys(data);
  const updateItem = (cat, i, item) => { const n = { ...data, [cat]: [...data[cat]] }; n[cat][i] = item; onChange(n); };
  const deleteItem = (cat, i) => { const n = { ...data, [cat]: [...data[cat]] }; n[cat] = n[cat].filter((_, j) => j !== i); onChange(n); };
  const addItem = (cat) => { const n = { ...data, [cat]: [...data[cat], { name: '', type: 'url', icon: '' }] }; onChange(n); };
  const addBadge = (cat) => { const n = { ...data, [cat]: [...data[cat], { name: '', type: 'badge' }] }; onChange(n); };
  const addCategory = () => { const name = prompt('Category name:'); if (name) onChange({ ...data, [name]: [] }); };
  const deleteCategory = (cat) => { const n = { ...data }; delete n[cat]; onChange(n); };

  return (
    <div className="admin-section">
      <h4>Skills</h4>
      {categories.map((cat) => (
        <div key={cat} className="admin-category-block">
          <div className="admin-card-header"><span>{cat}</span><button className="admin-btn danger small" onClick={() => deleteCategory(cat)}>Delete Category</button></div>
          {data[cat].map((item, i) => <SkillItemEditor key={i} item={item} onChange={(it) => updateItem(cat, i, it)} onDelete={() => deleteItem(cat, i)} />)}
          <div className="add-skill-row">
            <button className="admin-btn ghost small" onClick={() => addItem(cat)}>+ Icon Skill</button>
            <button className="admin-btn ghost small" onClick={() => addBadge(cat)}>+ Badge Skill</button>
          </div>
        </div>
      ))}
      <button className="admin-btn primary" onClick={addCategory}>+ Add Category</button>
    </div>
  );
}

// ─── Contact Editor ───
function ContactEditor({ data, onChange }) {
  const u = (k, v) => onChange({ ...data, [k]: v });
  return (
    <div className="admin-section">
      <h4>Contact</h4>
      <div className="admin-field"><label>Email</label><input className="admin-input" value={data.email} onChange={(e) => u('email', e.target.value)} /></div>
      <div className="admin-field"><label>Subtitle</label><textarea className="admin-textarea" rows={2} value={data.subtitle} onChange={(e) => u('subtitle', e.target.value)} /></div>
      <div className="admin-field"><label>GitHub URL</label><input className="admin-input" value={data.githubUrl} onChange={(e) => u('githubUrl', e.target.value)} /></div>
      <div className="admin-field"><label>LinkedIn URL</label><input className="admin-input" value={data.linkedinUrl} onChange={(e) => u('linkedinUrl', e.target.value)} /></div>
    </div>
  );
}

// ─── Footer Editor ───
function FooterEditor({ data, onChange }) {
  const u = (k, v) => onChange({ ...data, [k]: v });
  return (
    <div className="admin-section">
      <h4>Footer</h4>
      <div className="admin-field"><label>Text</label><input className="admin-input" value={data.text} onChange={(e) => u('text', e.target.value)} /></div>
      <div className="admin-field"><label>Quote</label><input className="admin-input" value={data.quote} onChange={(e) => u('quote', e.target.value)} /></div>
    </div>
  );
}

// ─── Main Admin Panel ───
const TABS = ['Hero', 'About', 'Projects', 'Skills', 'Contact', 'Footer'];

export default function AdminPanel({ data, onChange, onClose, onReset }) {
  const [tab, setTab] = useState(0);
  const [saved, setSaved] = useState(false);

  const handleSave = () => {
    if (savePortfolioData(data)) { setSaved(true); setTimeout(() => setSaved(false), 2000); }
  };

  const renderEditor = () => {
    switch (tab) {
      case 0: return <HeroEditor data={data.hero} onChange={(v) => onChange({ ...data, hero: v })} />;
      case 1: return <AboutEditor data={data.about} onChange={(v) => onChange({ ...data, about: v })} />;
      case 2: return <ProjectsEditor data={data.projects} onChange={(v) => onChange({ ...data, projects: v })} />;
      case 3: return <SkillsEditor data={data.skills} onChange={(v) => onChange({ ...data, skills: v })} />;
      case 4: return <ContactEditor data={data.contact} onChange={(v) => onChange({ ...data, contact: v })} />;
      case 5: return <FooterEditor data={data.footer} onChange={(v) => onChange({ ...data, footer: v })} />;
      default: return null;
    }
  };

  return (
    <div className="admin-panel">
      <div className="admin-header">
        <h3>Admin Panel</h3>
        <div className="admin-header-actions">
          <button className={`admin-btn primary${saved ? ' saved' : ''}`} onClick={handleSave}>{saved ? '✓ Saved!' : 'Save All'}</button>
          <button className="admin-btn ghost" onClick={onReset}>Reset</button>
          <button className="admin-btn ghost" onClick={onClose}>Close</button>
        </div>
      </div>
      <div className="admin-tabs">
        {TABS.map((t, i) => <button key={t} className={`admin-tab${tab === i ? ' active' : ''}`} onClick={() => setTab(i)}>{t}</button>)}
      </div>
      <div className="admin-body">{renderEditor()}</div>
    </div>
  );
}

export { PasscodeModal };
